// List of country codes for phone numbers
export interface CountryCode {
    code: string;
    name: string;
    flag: string; // Unicode flag emoji
}

export const countryCodes: CountryCode[] = [
    { code: '+233', name: 'Ghana', flag: '🇬🇭' },
    { code: '+254', name: 'Kenya', flag: '🇰🇪' },
    { code: '+27', name: 'South Africa', flag: '🇿🇦' },
    { code: '+234', name: 'Nigeria', flag: '🇳🇬' },
];

// Default to Ghana
export const DEFAULT_COUNTRY_CODE = '+233';

// Format phone number by removing whitespace and non-digit characters
export const formatPhoneNumber = (phoneNumber: string): string => {
    return phoneNumber.replace(/\s+/g, '');
};

// Format a full phone number with country code
export const formatFullPhoneNumber = (countryCode: string, phoneNumber: string): string => {
    const cleanedPhone = formatPhoneNumber(phoneNumber);
    
    // If the phone starts with 0, remove it
    const phoneWithoutLeadingZero = cleanedPhone.startsWith('0') 
        ? cleanedPhone.substring(1) 
        : cleanedPhone;
    
    return `${countryCode}${phoneWithoutLeadingZero}`;
};